/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import { createContext, useContext } from 'react';

type FormContextType = {
  errors: any;
  register: Function;
  setError?: Function
};

const FormContext = createContext<FormContextType>({ errors: {}, register: new Function(), setError: new Function() });
export const useFormContext = () => useContext(FormContext);
export default FormContext;